import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

import VehicleHistoryIntervalWidget from '../VehicleHistoryIntervalWidget/VehicleHistoryIntervalWidget';
import VehicleStatisticsWidget from '../VehicleStatisticsWidget/VehicleStatisticsWidget';
import VehicleStopSpeedWidget from '../VehicleStopSpeedWidget/VehicleStopSpeedWidget';
import VehiclePlayerWidget from '../VehiclePlayerWidget/VehiclePlayerWidget';
import VehicleSensorChartPicker from '../VehicleSensorChartPicker';

// Панель настроек истории ТС: интервал, статистика, плеер, сенсоры
function VehicleHistorySettings({
  intervalOption,
  setIntervalOption,
  setDisableExternalExtent,
  dateStart,
  setDateStart,
  dateFinish,
  setDateFinish,
  isValidDate,
  getCustomHistory,
  handleExportTracks,
  handleCurrentPosition,
  speedLimit,
  setSpeedLimit,
  stopTime,
  setStopTime,
  runRec,
  handleStart,
  handleStop,
  speedRec,
  setSpeedRec,
  coordsState,
  coords,
  setPositionHistory,
  onStopSliderDragging,
  formattedLastDate,
  onSaveMarker,
  hideSpeed,
  sensors,
  onClickAdd,
  vehicleId,
  enableGeozoneNames,
  setEnableGeozoneNames,
  enableMapRoutes,
  setEnableMapRoutes,
  timeZone,
}) {
  return (
    <Box>
      <VehicleHistoryIntervalWidget
        intervalOption={intervalOption}
        setIntervalOption={setIntervalOption}
        setDisableExternalExtent={setDisableExternalExtent}
        dateStart={dateStart}
        setDateStart={setDateStart}
        dateFinish={dateFinish}
        setDateFinish={setDateFinish}
        isValidDate={isValidDate}
        getCustomHistory={getCustomHistory}
        handleExportTracks={handleExportTracks}
        handleCurrentPosition={handleCurrentPosition}
        timeZone={timeZone}
      />

      <VehicleStatisticsWidget
        coordsState={coordsState}
        coords={coords}
        enableGeozoneNames={enableGeozoneNames}
        setEnableGeozoneNames={setEnableGeozoneNames}
        enableMapRoutes={enableMapRoutes}
        setEnableMapRoutes={setEnableMapRoutes}
      />

      <VehicleStopSpeedWidget
        speedLimit={speedLimit}
        setSpeedLimit={setSpeedLimit}
        stopTime={stopTime}
        setStopTime={setStopTime}
      />

      <VehiclePlayerWidget
        runRec={runRec}
        handleStart={handleStart}
        handleStop={handleStop}
        speedRec={speedRec}
        setSpeedRec={setSpeedRec}
        coordsState={coordsState}
        coords={coords}
        setPositionHistory={setPositionHistory}
        onStopSliderDragging={onStopSliderDragging}
        formattedLastDate={formattedLastDate}
        onSaveMarker={onSaveMarker}
        hideSpeed={hideSpeed}
      />

      <VehicleSensorChartPicker sensors={sensors} onClickAdd={onClickAdd} vehicleId={vehicleId} />
    </Box>
  );
}

VehicleHistorySettings.propTypes = {
  intervalOption: PropTypes.string.isRequired,
  setIntervalOption: PropTypes.func.isRequired,
  setDisableExternalExtent: PropTypes.func.isRequired,
  dateStart: PropTypes.instanceOf(Date),
  setDateStart: PropTypes.func.isRequired,
  dateFinish: PropTypes.instanceOf(Date),
  setDateFinish: PropTypes.func.isRequired,
  isValidDate: PropTypes.func.isRequired,
  getCustomHistory: PropTypes.func.isRequired,
  handleExportTracks: PropTypes.func,
  handleCurrentPosition: PropTypes.func.isRequired,
  speedLimit: PropTypes.number,
  setSpeedLimit: PropTypes.func.isRequired,
  stopTime: PropTypes.number,
  setStopTime: PropTypes.func.isRequired,
  runRec: PropTypes.bool.isRequired,
  handleStart: PropTypes.func.isRequired,
  handleStop: PropTypes.func.isRequired,
  speedRec: PropTypes.number.isRequired,
  setSpeedRec: PropTypes.func.isRequired,
  coordsState: PropTypes.arrayOf(
    PropTypes.shape({
      longitude: PropTypes.number,
      latitude: PropTypes.number,
      date: PropTypes.string,
      dateTime: PropTypes.string,
    }),
  ),
  coords: PropTypes.arrayOf(
    PropTypes.shape({
      longitude: PropTypes.number,
      latitude: PropTypes.number,
      date: PropTypes.string,
      dateTime: PropTypes.string,
    }),
  ),
  setPositionHistory: PropTypes.func.isRequired,
  onStopSliderDragging: PropTypes.func,
  formattedLastDate: PropTypes.string.isRequired,
  onSaveMarker: PropTypes.func.isRequired,
  hideSpeed: PropTypes.bool,
  sensors: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onClickAdd: PropTypes.func.isRequired,
  vehicleId: PropTypes.number,
  enableGeozoneNames: PropTypes.bool.isRequired,
  setEnableGeozoneNames: PropTypes.func.isRequired,
  enableMapRoutes: PropTypes.bool.isRequired,
  setEnableMapRoutes: PropTypes.func.isRequired,
  timeZone: PropTypes.string,
};

VehicleHistorySettings.defaultProps = {
  dateStart: null,
  dateFinish: null,
  handleExportTracks: null,
  speedLimit: null,
  stopTime: null,
  coordsState: [],
  coords: [],
  onStopSliderDragging: null,
  hideSpeed: false,
  vehicleId: null,
  timeZone: null,
};

export default VehicleHistorySettings;